"use client";
import EARTH from "@/public/earth_image.png";
import LOGO from "@/public/brand_logo.png";
import ROCKET from "@/public/rocket_image.png";
import TRUSTPILOT from "@/public/trustpilot.png";
import Image from "next/image";
import clsx from "clsx";

const SideImage = () => {
    return (
        <div className="bg-bg relative h-screen w-full flex flex-col items-center justify-between overflow-hidden"> {/* ✅ overflow-hidden to clip rocket/earth */}
            <div className={clsx(
                "absolute right-0 top-0 w-60",   // ✅ added top-0 so earth anchors correctly
                "lg:w-70", "xl:w-84"
            )}>
                <Image src={EARTH} alt="earth image"/>  {/* ✅ fixed typo: "earth imag e" */}
            </div>

            <div className={clsx(
                "relative z-10 w-full p-5 mt-70",   // ✅ z-10 so text sits above images
                "lg:px-16 lg:mt-60"
            )}>
                <div className="flex flex-row items-center gap-3">
                    <Image src={LOGO} alt="Rocket Wave"/>
                    <Image src={TRUSTPILOT} alt="Trustpilot"/>
                </div>
                <div className={clsx(
                    "mt-12 flex flex-col gap-3",
                    "lg:mt-10"
                )}>
                    <p className={clsx(
                        "text-[20px] font-bold",
                        "lg:text-[25px]", "xl:text-[36px]"
                    )}>
                        Ready, Set, and Grow <span className="text-brand">Beyond the Space!</span>
                    </p>
                    <span className={clsx(
                        "text-[15px] font-normal text-darkgray",  // ✅ font-regular → font-normal (valid Tailwind)
                        "xl:text-[18px]"
                    )}>
                        With our easy onboarding process, forming a company is child&apos;s play. {/* ✅ fixed "east" typo + apostrophe encoding */}
                        We take care of everything, from paperwork to delivering all necessary documents on time.
                    </span>
                </div>
            </div>

            <div className={clsx(
                "absolute right-0 bottom-0 z-0",   // ✅ z-0 so rocket stays behind text
                "lg:w-100", "xl:w-123.75"
            )}>
                <Image src={ROCKET} alt="rocket image"/>
            </div>
        </div>
    )
}

export default SideImage;